/**
 * Target for a legacy `/m/<path>?<query>` link: the same path and query in the
 * responsive app. The path is normalised so it can never become
 * protocol-relative (`//host`) or use backslashes.
 */
export function legacyMobileTarget(splat: string | undefined, searchStr: string): string {
  const path = (splat ?? "")
    .replace(/\\/g, "/")
    .replace(/^\/+/, "")
    .replace(/\/{2,}/g, "/");
  const search =
    searchStr && searchStr !== "?" ? (searchStr.startsWith("?") ? searchStr : `?${searchStr}`) : "";
  return `/${path}${search}`;
}
